import { MatDialog } from '@angular/material/dialog';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@alfresco/adf-core';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { ImprimirControleComponent } from '../imprimir-controle/imprimir-controle.component';
import { ControleComponent } from '../controle/controle.component';
import GenericReturn from 'app/model/generic/generic-return.model';

@Component({
  selector: 'app-requisitar-conteudo',
  templateUrl: './requisitar-conteudo.component.html',
  styleUrls: ['./requisitar-conteudo.component.scss']
})
export class RequisitarConteudoComponent implements OnInit {
  result ;
  resultEmRecuperacao;
  loading = false;
  pendenteRecuperacao = [];
  emRecuperacao = [];
  rgInput ;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  logIsvisivel = false;
  logs = [];
  controles = [];
  adm = false;
   acervo = false;
   solicitacao = true;

   solicitacoesConteudo: any;
   showCheck = false;
   solicitacaoId;

   constructor(
     private service : SolicitacaoService,
     private _snackBar: MatSnackBar,
     private dialog: MatDialog) { }

   ngOnInit() {
    this.buscarSolicitacoesConteudo();
   }

   buscarSolicitacoesConteudo() {
    this.service.buscarSolicitacoesConteudo().subscribe(data => {
      if (data.success) {
        this.solicitacoesConteudo = data.result;
      }
    }, err => {
      console.error(err);
    })
   }

   buscarDocumentosSelecionados(solicId: number) {
    this.service.buscarConteudoSolicitacao(solicId).subscribe(data => {
      if (data.success) {
        this.pendenteRecuperacao = data.result;
      }
    }, err => {
      console.error(err);
    });
   }

   buscarDocumentosSelecionadosRecuperacaoPendente(solicId: number) {
    this.pendenteRecuperacao = [];
    this.service.buscarConteudoSolicitacaoRequisicaoPendente(solicId).subscribe(data => {
      if (data.success) {
        this.pendenteRecuperacao = data.result;
      }
    }, err => {
      console.error(err);
    });
   }

   buscarDocumentosSelecionadosEmRecuperacao(solicId: number) {
    this.service.buscarConteudoSolicitacaoEmRecuperacao(solicId).subscribe(data => {
      if (data.success) {
        this.emRecuperacao = data.result;
      }
    }, err => {
      console.error(err);
    });
   }

   selectSolicitacao(event: any) {
    this.showCheck = true;
    this.solicitacaoId = event.value;
    //this.buscarDocumentosSelecionados(event.value);
    this.buscarDocumentosSelecionadosRecuperacaoPendente(event.value);
    this.buscarDocumentosSelecionadosEmRecuperacao(event.value);
   }

   addControle() {
     const dialogRef = this.dialog.open(ControleComponent, {
       width: '70%',
       data: {tipoSolicitacao: 'recuperacaoRecipiente'}
     });
     dialogRef.afterClosed().subscribe((result) => {
       this.carregarPendenteRecuperacao();
       console.log(`The dialog was closed - ${result}`);
       console.log(result);
     });
   }

   imprimirControle() {
     const dialogRef = this.dialog.open(ImprimirControleComponent, {
       width: '40%',
       data: {tipoSolicitacao: '0'}
     });
     dialogRef.afterClosed().subscribe((result) => {
       console.log(result);
     });
   }

   listarControles(idsCaixas) {
     this.service.listarControles(idsCaixas).subscribe(data => {
       this.controles = data;
     }, err => {
       console.error(err);
     });
   }

   relatorioCaixasPendentes() {
     if (this.result.result.length === 0 ) {
       this.openSnackBarError('Nenhuma caixa pendente recuperação !');
     } else {
     window.open(`relatorio-caixas-pendente-recuperacao`,
     '_blank',
     'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
     }
   }

   alterarVisualizacaoLog(){
     if(this.logIsvisivel){
       this.logIsvisivel = false;
     }else{
       this.logIsvisivel = true;
     }
   }

   carregarPendenteRecuperacao(){
     this.loading = true;
     this.service.listarCaixasPendeteRecuperacao().subscribe(data=>{
       this.result = data;
       if(this.result.cod == 200){
         this.pendenteRecuperacao = this.result.result;
         this.loading = false;
         let caixasIds = [];
         this.pendenteRecuperacao.map(el => {
           if (el.idControle !== null) {
             caixasIds.push(el.id);
           }
         });
         this.listarControles(caixasIds);
       }
     })
   }

   carregarEmRecuperacao(){
     let user = localStorage.getItem('APS_USERNAME');
     let obj = {"rgCaixa" : "", username: user};
     this.loading = true;
     this.service.caixasEmRecuperacao(obj).subscribe(data=>{
       this.resultEmRecuperacao = data;
       if(this.resultEmRecuperacao.cod == 200){
         this.emRecuperacao = this.resultEmRecuperacao.result;
         this.loading = false;
       }else {
         this.openSnackBarError(this.resultEmRecuperacao.message)
         this.loading = false;
       }
     })


   }

   rgEmRecuperacao(){
     if(this.rgInput != ""){
       this.incluirRGEmRecuperacao(this.rgInput );
       this.rgInput = "";
     }

   }

   selecionarTodos() {
    let iterador = 0;
     this.pendenteRecuperacao.map(el => {
      iterador++;
       this.incluirRGEmRecuperacao(el.codConteudo.toString());
     });
   }

   incluirRGEmRecuperacao(codConteudo){
    let rgCaixa;
    this.pendenteRecuperacao.forEach(item => {
      if (item.codConteudo.toString() === codConteudo.toString()) {
        rgCaixa = item.rgCaixa;
      }
    });
     let obj = {"rgCaixa" : rgCaixa, "conteudoId": codConteudo};
     this.loading = true;
     this.service.recuperarConteudoUnico(obj).subscribe(data => {
       this.result = data;
       if (data.success) {
        this.openSnackBarSuccess(`Contéudo: ${codConteudo} em recuperação`);
        this.buscarDocumentosSelecionadosRecuperacaoPendente(this.solicitacaoId);
        this.buscarDocumentosSelecionadosEmRecuperacao(this.solicitacaoId);
       } else {
        this.openSnackBarError(data.message);
       }
       this.loading = false;
     }, err => {
      console.error(err);
      this.loading = false;
     });
   }

   openSnackBarSuccess(message: string) {
     this._snackBar.open(message, '', {
       horizontalPosition: this.horizontalPosition,
       verticalPosition: this.verticalPosition,
       duration: 4000,
       panelClass: ['success-snackbar']
     });
   }

   openSnackBarError(message: string) {
     this._snackBar.open(message,'', {
       horizontalPosition: this.horizontalPosition,
       verticalPosition: this.verticalPosition,
       duration: 3000,
       panelClass: ['error-snackbar']
     });
   }

   recuperarRecipientesUser(){
     let user = localStorage.getItem('APS_USERNAME');
     let obj = {"rgCaixa" : "", username: user};
     this.loading = true;
     this.service.recuperarRecipientesUser(obj).subscribe(data=>{
       this.result = data;
       if(this.result.cod == 200){
         for(let i = 0 ; i < this.result.result.length; i++){
           this.logs.push("Caixa RG "+ this.result.result[i].rgCaixa + " recuperada !" + ' Controle: ' + this.result.result[i].idControle);
         }
         this.carregarEmRecuperacao();
         this.carregarPendenteRecuperacao();
         this.openSnackBarSuccess("Caixas recuperadas com sucesso!");
       }else {
         this.openSnackBarError(this.result.message)
         this.loading = false;
       }
     })
   }

   recuperarConteudos() {
    this.service.recuperarConteudos(this.solicitacaoId).subscribe(data => {
      console.log(data);
      if (data.success) {
        this.emRecuperacao = [];
        this.pendenteRecuperacao = [];
        this.openSnackBarSuccess(data.message);
      } else {
        this.openSnackBarError(data.message);
      }
    }, err => {
      console.error(err);
    });
   }
}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/requisitar-conteudo/requisitar-conteudo.component.ts